<template>
  <div>
    <video ref="videoPlayer" class="video-js vjs-big-play-centered"></video>
  </div>
</template>
<script>
  import videojs from 'video.js'
  import 'video.js/dist/video-js.css'
  export default {
    name: 'VideoPlayer',
    props: {
      options: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {
        player: null,
      }
    },
    mounted() {
      this.player = videojs(this.$refs.videoPlayer, this.options, () => {
        this.player.log('onPlayerReady', this)
        this.player.on('play', (e) => {
          this.$emit('play', e)
        })
        this.player.on('pause', (e) => {
          const currentTime = this.player.currentTime()
          console.log(currentTime)
          this.$emit('pause', {
            $event: e,
            currentTime,
          })
        })
        this.player.on('ended', (e) => {
          this.$emit('ended', {
            $event: e,
            currentTime: this.player.currentTime(),
          })
        })
        this.player.on('waiting', (e) => {
          this.$emit('waiting', e)
        })
        // this.player.on('playing', (e) => {
        //   this.$emit('playing', e)
        // })
        this.player.on('timeupdate', (e) => {
          this.$emit('timeupdate', {
            $event: e,
            currentTime: this.player.currentTime(),
          })
        })

        // this.player.on('loadeddata', (e) => {
        //   this.$emit('loadeddata', e)
        // })
        this.player.on('canplay', (e) => {
          this.$emit('canplay', e)
        })
        this.player.on('canplaythrough', (e) => {
          this.$emit('canplaythrough', e)
        })
        this.player.on('statechanged', (e) => {
          this.$emit('statechanged', e)
        })
        this.player.on('ready', (e) => {
          this.$emit('ready', e)
        })
      })
    },
    beforeUnmount() {
      if (this.player) {
        this.player.dispose()
      }
    },
    methods: {
      pause() {
        if (this.player) {
          this.player.pause()
        }
      },
      setCurrentTime(time) {
        if (this.player) {
          this.player.currentTime(time)
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .video-js {
    width: 100%;
    height: 200px;
  }
</style>
